export default [
  { id: 0, name: 'Jänner' },
  { id: 1, name: 'Februar' },
  { id: 2, name: 'März' },
  { id: 3, name: 'April' },
  { id: 4, name: 'Mai' },
  { id: 5, name: 'Juni' },
  { id: 6, name: 'Juli' },
  { id: 7, name: 'August' },
  { id: 8, name: 'September' },
  { id: 9, name: 'Oktober' },
  { id: 10, name: 'November' },
  { id: 11, name: 'Dezember' },
];
